import React from "react";

import { useTranslation } from "utils";

import { Flex, Typography } from "components";

import ResilienceScoreTimelineBarChart from "pages/app/resilience-score/components/resilience-score-context-drawer/ResilienceScoreTimelineBarChart";
import { type ResilienceTimelineRow } from "pages/app/resilience-score/utils/ResilienceScoreContextDrawerUtils";

type ResilienceScoreTimelineCardProps = {
  rows: ResilienceTimelineRow[];
  maxScore: number;
};

const ResilienceScoreTimelineCard = ({ rows, maxScore }: ResilienceScoreTimelineCardProps) => {
  const { t } = useTranslation(["resilienceScore"]);

  return (
    <Flex vertical className="rsd-card rsd-timeline-card">
      <Typography variant="paragraph-l" className="rsd-timeline-title">
        {t("resilienceScoreContextDrawer.timeline.title", "Score Timeline")}
      </Typography>
      <div className="rsd-timeline-chart">
        <ResilienceScoreTimelineBarChart rows={rows} maxScore={maxScore} />
      </div>
      <Flex className="rsd-timeline-legend" justify="space-evenly" gap="0.75rem" wrap>
        <Flex gap="0.5rem">
          <span className="rsd-legend-dot soil" />
          <Typography variant="paragraph-s" className="rsd-legend-label margin-0">
            {t("resilienceScoreContextDrawer.timeline.legend.soilHealth", "Soil Health")}
          </Typography>
        </Flex>
        <Flex gap="0.5rem">
          <span className="rsd-legend-dot water" />
          <Typography variant="paragraph-s" className="rsd-legend-label margin-0">
            {t("resilienceScoreContextDrawer.timeline.legend.waterManagement", "Water Management")}
          </Typography>
        </Flex>
        <Flex gap="0.5rem">
          <span className="rsd-legend-dot biodiversity" />
          <Typography variant="paragraph-s" className="rsd-legend-label margin-0">
            {t("resilienceScoreContextDrawer.timeline.legend.biodiversity", "Biodiversity")}
          </Typography>
        </Flex>
        <Flex gap="0.5rem">
          <span className="rsd-legend-dot unknown" />
          <Typography variant="paragraph-s" className="rsd-legend-label margin-0">
            {t("resilienceScoreContextDrawer.timeline.legend.unknown", "Unknown")}
          </Typography>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default ResilienceScoreTimelineCard;
